import { SliderStateType } from '@kubit/web-ui-components/slider/types';
import { ButtonSizeType, ButtonVariantType } from '../../variants';
import { activeTrackCommonStyles, commonStyles, containerCommonStyles, helperTextCommonStyles, inactiveTrackCommonStyles, labelCommonStyles, rightThumbCommonStyles, thumbCommonStyles, thumbIconCommonStyles, thumbRightIconCommonStyles, } from '../commonStyles';
import { SliderVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [SliderVariantType.DEFAULT]: {
            ...commonStyles(FOUNDATIONS),
            states: {
                [SliderStateType.DEFAULT]: {
                    container: {
                        ...containerCommonStyles(FOUNDATIONS),
                        cursor: 'default',
                    },
                    label: {
                        ...labelCommonStyles(FOUNDATIONS),
                    },
                    helperText: {
                        ...helperTextCommonStyles(FOUNDATIONS),
                    },
                    thumb: {
                        ...thumbCommonStyles(FOUNDATIONS),
                    },
                    rightThumb: {
                        ...rightThumbCommonStyles(FOUNDATIONS),
                    },
                    thumbIcon: {
                        ...thumbIconCommonStyles(FOUNDATIONS),
                    },
                    rightThumbIcon: {
                        ...thumbRightIconCommonStyles(FOUNDATIONS),
                    },
                    activeTrack: {
                        ...activeTrackCommonStyles(FOUNDATIONS),
                    },
                    inactiveTrack: {
                        ...inactiveTrackCommonStyles(FOUNDATIONS),
                    },
                    incrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                    decrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                },
                [SliderStateType.HOVER]: {
                    container: {
                        ...containerCommonStyles(FOUNDATIONS),
                        cursor: 'grab',
                    },
                    label: {
                        ...labelCommonStyles(FOUNDATIONS),
                    },
                    helperText: {
                        ...helperTextCommonStyles(FOUNDATIONS),
                    },
                    thumb: {
                        ...thumbCommonStyles(FOUNDATIONS),
                    },
                    rightThumb: {
                        ...rightThumbCommonStyles(FOUNDATIONS),
                    },
                    thumbIcon: {
                        ...thumbIconCommonStyles(FOUNDATIONS),
                    },
                    rightThumbIcon: {
                        ...thumbRightIconCommonStyles(FOUNDATIONS),
                    },
                    activeTrack: {
                        ...activeTrackCommonStyles(FOUNDATIONS),
                    },
                    inactiveTrack: {
                        ...inactiveTrackCommonStyles(FOUNDATIONS),
                    },
                    incrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                    decrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                },
                [SliderStateType.PRESSED]: {
                    container: {
                        ...containerCommonStyles(FOUNDATIONS),
                        cursor: 'grabbing',
                    },
                    label: {
                        ...labelCommonStyles(FOUNDATIONS),
                    },
                    helperText: {
                        ...helperTextCommonStyles(FOUNDATIONS),
                    },
                    thumb: {
                        ...thumbCommonStyles(FOUNDATIONS),
                    },
                    rightThumb: {
                        ...rightThumbCommonStyles(FOUNDATIONS),
                    },
                    thumbIcon: {
                        ...thumbIconCommonStyles(FOUNDATIONS),
                    },
                    rightThumbIcon: {
                        ...thumbRightIconCommonStyles(FOUNDATIONS),
                    },
                    activeTrack: {
                        ...activeTrackCommonStyles(FOUNDATIONS),
                    },
                    inactiveTrack: {
                        ...inactiveTrackCommonStyles(FOUNDATIONS),
                    },
                    incrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                    decrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                },
                [SliderStateType.DISABLED]: {
                    container: {
                        ...containerCommonStyles(FOUNDATIONS),
                        cursor: 'default',
                    },
                    label: {
                        ...labelCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    helperText: {
                        ...helperTextCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    thumb: {
                        ...thumbCommonStyles(FOUNDATIONS),
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    },
                    rightThumb: {
                        ...rightThumbCommonStyles(FOUNDATIONS),
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    },
                    thumbIcon: {
                        ...thumbIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    rightThumbIcon: {
                        ...thumbRightIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    activeTrack: {
                        ...activeTrackCommonStyles(FOUNDATIONS),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_50,
                    },
                    inactiveTrack: {
                        ...inactiveTrackCommonStyles(FOUNDATIONS),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                    },
                    incrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                    decrementButton: {
                        variant: ButtonVariantType.ICON_PRIMARY,
                        size: ButtonSizeType.ICON_MEDIUM,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map